import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InputFieldAcceptService {
    specialChar: Number = 31;
    specialCharDot: Number = 46;
    digit0: Number = 48;
    digit9: Number = 57;
    uppercaseA: Number = 65;
    uppercaseZ: Number = 90;
    lowercaseA: Number = 97;
    lowercaseZ: Number = 122;

    constructor() { }

    numberAndAtoZ(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > this.specialChar && (charCode < this.digit0 || charCode > this.digit9) && (charCode < this.uppercaseA || charCode > this.uppercaseZ)) {
            return false;
        }
        return true;
    }

    numberAndDot(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > this.specialChar && (charCode < this.digit0 || charCode > this.digit9) && (charCode < this.specialCharDot || charCode > this.specialCharDot)) {
            return false;
        }
        return true;
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > this.specialChar && (charCode < this.digit0 || charCode > this.digit9)) {
            return false;
        }
        return true;
    }

}